import { FilterConfig } from '../../../components/Tables/advancedRecord/FilterBar';
import { DropdownDTO } from '../../../types/common/DropdownDTO';

export const getSaleHistoryFilters = (
  documentTypeDropdown: DropdownDTO[],
  customersDropdown: DropdownDTO[],
  canSupportView = false
): FilterConfig[] => {
  const filters: FilterConfig[] = [
    {
      name: 'documentType',
      label: 'Tipo de Documento',
      type: 'select',
      options: documentTypeDropdown,
      colSpan: 2,
    },

    {
      name: 'documentNumber',
      label: 'Número de Documento',
      type: 'text',
      colSpan: 2,
    },

    {
      name: 'customerId',
      label: 'Cliente',
      type: 'searchSelect',
      options: customersDropdown,
      colSpan: 3,
    },

    {
      name: 'saleDate',
      label: 'Fecha de Venta',
      type: 'date',
      colSpan: 3,
    },

    {
      name: 'total',
      label: 'Total Venta',
      type: 'number',
      colSpan: 2,
    },
  ];
  if (canSupportView) {
    filters.push({
      name: 'status', label: 'Estado de soporte', type: 'select', colSpan: 2,
      options: [{ id: 'DRAFT_CANCELLED', name: 'Borrador descartado' }] as any,
    });
    filters.push({ name: 'includeDraftCancelled', label: 'Incluir borradores descartados', type: 'checkbox', colSpan: 2 } as any);
  }
  return filters;
};
